import { render } from "./pegawai-detail-right.vue?vue&type=template&id=4011d1a4&scoped=true"
import script from "./pegawai-detail-right.vue?vue&type=script&lang=js"
export * from "./pegawai-detail-right.vue?vue&type=script&lang=js"

import "./pegawai-detail-right.vue?vue&type=style&index=0&id=4011d1a4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4011d1a4"]])

export default __exports__